import React from 'react'
import { Container, Alert } from '@mui/material'
import Loader from 'gui/components/common/Loader'

export interface ContentDetailQueryStatesProps {
  /** Query is in flight */
  loading: boolean
  /** Query error (only .message is used) */
  error: Error | undefined
  /** Query returned data (we have something to show) */
  hasData: boolean
  /** Title for the error alert (e.g. "Error loading Course") */
  errorTitle: string
  /** Title for the not-found alert (e.g. "Course not found") */
  notFoundTitle: string
  /** Detail line for not-found (e.g. "No Course found with ID: 123") */
  notFoundDetail: string
  /** Rendered when not loading, no error, and hasData */
  children: React.ReactNode
}

/**
 * Handles loading, error, and not-found states for content detail query pages.
 * Renders Loader, error Alert, or not-found Alert when appropriate; otherwise renders children.
 */
function ContentDetailQueryStates ({
  loading,
  error,
  hasData,
  errorTitle,
  notFoundTitle,
  notFoundDetail,
  children,
}: ContentDetailQueryStatesProps) {
  if (loading) {
    return <Loader />
  }

  if (error) {
    return (
      <Container>
        <Alert severity="error" sx={{ mt: 3 }}>
          <div>
            <strong>{errorTitle}</strong>
          </div>
          <div>{error.message}</div>
        </Alert>
      </Container>
    )
  }

  if (!hasData) {
    return (
      <Container>
        <Alert severity="warning" sx={{ mt: 3 }}>
          <div>
            <strong>{notFoundTitle}</strong>
          </div>
          <div>{notFoundDetail}</div>
        </Alert>
      </Container>
    )
  }

  return <>{children}</>
}

export default ContentDetailQueryStates
